module.exports = __webpack_public_path__ + "static/img/2-1.8a6df3a7.png";